import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOvercast = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.15.5v.74M1.98 1.96l.74.74M12.33 1.96l-.74.74M.5 7.15h.74M16.21 12.08A2.21 2.21 0 0 0 13.9 9a4.06 4.06 0 0 0-7.84 1.11 3.7 3.7 0 0 0 .35 7.39h8.13a3 3 0 0 0 1.67-5.42ZM10.47 4.19a4.43 4.43 0 0 0-7.75 2.94A4.37 4.37 0 0 0 3 8.58",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgIconOvercast as ReactComponent };
